<!--
 * @Author: Gaho
 * @Date: 2024-04-18 14:22:12
 * @LastEditors: Gaho
 * @LastEditTime: 2024-04-18 17:29:30
 * @Description: 
-->
<template>
    <CasinoHistoryHeaderCell
        :text="t.RoundId.toUpperCase()"
        class="md:flex-[0.4] flex-[0.6] sm:flex-[0.8]"
    />
    <CasinoHistoryHeaderCell 
        class="md:flex-[0.4] flex-[0.6] sm:flex-[0.8]" 
        :text="t.Multiplier.toUpperCase()" 
    />
    <CasinoHistoryHeaderCell
        :text="t.ID.toUpperCase()"
        class="md:flex-[2] flex-[2] sm:flex-[2]"
    />
</template>
<script setup lang="ts">
import useTranslation from '~/i18n/useTransLation';

const t = useTranslation();
const props = defineProps({
    isMobileMode: Boolean, // 声明出来，否则控制台一直打印 warn 信息 
});

</script>
